import axios from 'axios';
import store from '../store/store.ts';
import showMessage from '../utils/showSocketMessage.js';
import { handleLogout, isAuthError } from '../utils/auth.js';

const mainFetch = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/expense`,
});

mainFetch.interceptors.request.use(
  (config) => {
    const token = store.getState().user.token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

mainFetch.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (isAuthError(error)) {
      handleLogout();
    } else if (error.response) {
      const message =
        error.response.data?.message ||
        'Server error occurred. Please try again.';
      showMessage(message, 'error');
    } else if (error.request) {
      showMessage(
        'Unable to reach server. Please check your connection.',
        'error'
      );
    }
    return Promise.reject(error);
  }
);

export const getExpenses = () => {
  return mainFetch.get('/');
};

export const optimizeCosts = (data, currentState = null) => {
  let records = currentState;
  if (!records) {
    const stored = JSON.parse(localStorage.getItem('statusAnalyzeFile')) || {
      status: 'none',
      records: null,
    };
    records = stored.records;
  }
  if (!records) {
    return;
  }
  records = JSON.parse(JSON.stringify(records));

  return mainFetch
    .post('/search', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      let responseData = response.data;
      responseData.forEach((responseItem) => {
        let recordItem = records.find((item) => item.id === responseItem.id);
        if (recordItem) {
          responseItem.optimizationOptions.forEach((responseOption) => {
            let recordOption = recordItem.optimizationOptions.find(
              (opt) => opt.id === responseOption.id
            );
            if (recordOption) {
              Object.assign(recordOption, responseOption);
            }
          });
        }
      });

      return records;
    })
    .catch(() => {
      return null;
    });
};

export const askChat = (optionId, data) => {
  return mainFetch
    .post(`/ask/${optionId}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const textChat = (optionId, data) => {
  return mainFetch
    .post(`/text/${optionId}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    });
};
